import {
  AngleToDirections_default,
  Const_default,
  ScreenXYToWorldXY_default
} from "./chunk-WFQKEYPG.js";
import {
  EventEmitterMethods_default
} from "./chunk-D5JVWJXO.js";
import {
  init_shim
} from "./chunk-XJTZ422K.js";

// node_modules/phaser3-rex-plugins/plugins/virtualjoystick.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/input/virtualjoystick/VirtualJoyStick.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/touchcursor.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/input/touchcursor/TouchCursor.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/utils/input/VectorToCursorKeys.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/utils/input/CursorKeys.js
init_shim();
var Key = Phaser.Input.Keyboard.Key;
var KeyCodes = Phaser.Input.Keyboard.KeyCodes;
var CursorKeys = class {
  constructor(scene) {
    this.cursorKeys = {
      up: new Key(scene, KeyCodes.UP),
      down: new Key(scene, KeyCodes.DOWN),
      left: new Key(scene, KeyCodes.LEFT),
      right: new Key(scene, KeyCodes.RIGHT)
    };
    this.noKeyDown = true;
  }
  shutdown(fromScene) {
    for (var key in this.cursorKeys) {
      this.cursorKeys[key].destroy();
    }
    this.cursorKeys = void 0;
  }
  destroy(fromScene) {
    shutdown(fromScene);
  }
  createCursorKeys() {
    return this.cursorKeys;
  }
  setKeyState(keyName, isDown) {
    var key = this.cursorKeys[keyName];
    if (!key.enabled) {
      return this;
    }
    if (isDown) {
      this.noKeyDown = false;
    }
    if (key.isDown !== isDown) {
      FakeEvent.timeStamp = Date.now();
      FakeEvent.keyCode = key.keyCode;
      if (isDown) {
        key.onDown(FakeEvent);
      } else {
        key.onUp(FakeEvent);
      }
    }
    return this;
  }
  clearAllKeysState() {
    this.noKeyDown = true;
    for (var keyName in this.cursorKeys) {
      this.setKeyState(keyName, false);
    }
    return this;
  }
  getKeyState(keyName) {
    return this.cursorKeys[keyName];
  }
  get upKeyDown() {
    return this.cursorKeys.up.isDown;
  }
  get downKeyDown() {
    return this.cursorKeys.down.isDown;
  }
  get leftKeyDown() {
    return this.cursorKeys.left.isDown;
  }
  get rightKeyDown() {
    return this.cursorKeys.right.isDown;
  }
  get anyKeyDown() {
    return !this.noKeyDown;
  }
};
var FakeEvent = {
  timeStamp: 0,
  keyCode: 0,
  altKey: false,
  ctrlKey: false,
  shiftKey: false,
  metaKey: false,
  location: 0
};
var CursorKeys_default = CursorKeys;

// node_modules/phaser3-rex-plugins/plugins/utils/math/RadToDeg.js
init_shim();
var RAD_TO_DEG = 180 / Math.PI;
var RadToDeg = function(radians) {
  return radians * RAD_TO_DEG;
};
var RadToDeg_default = RadToDeg;

// node_modules/phaser3-rex-plugins/plugins/utils/input/VectorToCursorKeys.js
var GetValue = Phaser.Utils.Objects.GetValue;
var GetDist = Phaser.Math.Distance.Between;
var GetAngle = Phaser.Math.Angle.Between;
var VectorToCursorKeys = class extends CursorKeys_default {
  constructor(scene, config) {
    super(scene);
    this.resetFromJSON(config);
  }
  resetFromJSON(o) {
    if (this.start == void 0) {
      this.start = { x: 0, y: 0 };
    }
    if (this.end == void 0) {
      this.end = { x: 0, y: 0 };
    }
    this._enable = void 0;
    this.setEnable(GetValue(o, "enable", true));
    this.setMode(GetValue(o, "dir", "8dir"));
    this.setDistanceThreshold(GetValue(o, "forceMin", 16));
    var startX = GetValue(o, "start.x", null);
    var startY = GetValue(o, "start.y", null);
    var endX = GetValue(o, "end.x", null);
    var endY = GetValue(o, "end.y", null);
    this.setVector(startX, startY, endX, endY);
    return this;
  }
  toJSON() {
    return {
      enable: this.enable,
      dir: this.dirMode,
      forceMin: this.forceMin,
      start: {
        x: this.start.x,
        y: this.start.y
      },
      end: {
        x: this.end.x,
        y: this.end.y
      }
    };
  }
  setMode(m) {
    if (typeof m === "string") {
      m = Const_default[m];
    }
    this.dirMode = m;
    return this;
  }
  get enable() {
    return this._enable;
  }
  set enable(e) {
    if (this._enable === e) {
      return;
    }
    if (!e) {
      this.clearVector();
    }
    this._enable = e;
    return this;
  }
  setEnable(e) {
    if (e === void 0) {
      e = true;
    }
    this.enable = e;
    return this;
  }
  toggleEnable() {
    this.setEnable(!this.enable);
    return this;
  }
  setDistanceThreshold(d) {
    if (d < 0) {
      d = 0;
    }
    this.forceMin = d;
    return this;
  }
  clearVector() {
    this.start.x = 0;
    this.start.y = 0;
    this.end.x = 0;
    this.end.y = 0;
    this.clearAllKeysState();
    return this;
  }
  setVector(x0, y0, x1, y1) {
    if (!this.enable) {
      return this;
    }
    if (x0 === null) {
      this.clearVector();
      return this;
    }
    if (x1 === void 0) {
      x1 = x0;
      x0 = 0;
      y1 = y0;
      y0 = 0;
    }
    this.start.x = x0;
    this.start.y = y0;
    this.end.x = x1;
    this.end.y = y1;
    if (this.forceMin > 0 && this.force < this.forceMin) {
      this.clearVector();
      return this;
    }
    this.noKeyDown = true;
    var dirStates = AngleToDirections_default(this.angle, this.dirMode, true);
    for (var dir in dirStates) {
      this.setKeyState(dir, dirStates[dir]);
    }
    return this;
  }
  get forceX() {
    return this.end.x - this.start.x;
  }
  get forceY() {
    return this.end.y - this.start.y;
  }
  get force() {
    return GetDist(this.start.x, this.start.y, this.end.x, this.end.y);
  }
  get rotation() {
    return GetAngle(this.start.x, this.start.y, this.end.x, this.end.y);
  }
  get angle() {
    return RadToDeg_default(this.rotation);
  }
  get octant() {
    var octant = 0;
    if (this.rightKeyDown) {
      octant = this.downKeyDown ? 45 : 0;
    } else if (this.downKeyDown) {
      octant = this.leftKeyDown ? 135 : 90;
    } else if (this.leftKeyDown) {
      octant = this.upKeyDown ? 225 : 180;
    } else if (this.upKeyDown) {
      octant = this.rightKeyDown ? 315 : 270;
    }
    return octant;
  }
};
var VectorToCursorKeys_default = VectorToCursorKeys;

// node_modules/phaser3-rex-plugins/plugins/input/touchcursor/TouchCursor.js
var GetValue2 = Phaser.Utils.Objects.GetValue;
var CircleClass = Phaser.Geom.Circle;
var CircleContains = Phaser.Geom.Circle.Contains;
var TouchCursor = class extends VectorToCursorKeys_default {
  constructor(gameObject, config) {
    var scene = gameObject.scene;
    super(scene, config);
    var eventEmitter = GetValue2(config, "eventEmitter", void 0);
    var EventEmitterClass = GetValue2(config, "EventEmitterClass", void 0);
    this.setEventEmitter(eventEmitter, EventEmitterClass);
    this.scene = scene;
    this.mainCamera = scene.sys.cameras.main;
    this.pointer = void 0;
    this.gameObject = gameObject;
    this.radius = GetValue2(config, "radius", 100);
    gameObject.setInteractive(new CircleClass(gameObject.displayOriginX, gameObject.displayOriginY, this.radius), CircleContains);
    this.boot();
  }
  resetFromJSON(o) {
    super.resetFromJSON(o);
    this.pointer = void 0;
    return this;
  }
  toJSON() {
    var o = super.toJSON();
    o.radius = this.radius;
    return o;
  }
  boot() {
    this.gameObject.on("pointerdown", this.onKeyDownStart, this);
    this.gameObject.on("pointerover", this.onKeyDownStart, this);
    this.scene.input.on("pointermove", this.onKeyDown, this);
    this.scene.input.on("pointerup", this.onKeyUp, this);
    this.gameObject.once("destroy", this.onParentDestroy, this);
  }
  shutdown(fromScene) {
    if (!this.scene) {
      return;
    }
    this.scene.input.off("pointermove", this.onKeyDown, this);
    this.scene.input.off("pointerup", this.onKeyUp, this);
    this.destroyEventEmitter();
    this.scene = void 0;
    this.mainCamera = void 0;
    this.pointer = void 0;
    this.gameObject = void 0;
    super.shutdown();
  }
  destroy(fromScene) {
    this.shutdown(fromScene);
  }
  onParentDestroy(parent, fromScene) {
    this.destroy(fromScene);
  }
  onKeyDownStart(pointer) {
    if (!pointer.isDown || this.pointer !== void 0) {
      return;
    }
    this.pointer = pointer;
    this.onKeyDown(pointer);
    this.emit("pointerdown", pointer);
  }
  onKeyDown(pointer) {
    if (this.pointer !== pointer) {
      return;
    }
    var camera = pointer.camera;
    if (!camera) {
      return;
    }
    var gameObject = this.gameObject;
    var worldXY = this.end;
    if (camera !== this.mainCamera) {
      worldXY = ScreenXYToWorldXY_default(pointer.x, pointer.y, camera, worldXY);
    } else {
      worldXY.x = pointer.worldX;
      worldXY.y = pointer.worldY;
    }
    var startX = gameObject.x;
    var startY = gameObject.y;
    if (gameObject.scrollFactorX === 0) {
      startX += camera.scrollX;
    }
    if (gameObject.scrollFactorY === 0) {
      startY += camera.scrollY;
    }
    this.setVector(startX, startY, worldXY.x, worldXY.y);
    this.emit("update");
  }
  onKeyUp(pointer) {
    if (this.pointer !== pointer) {
      return;
    }
    this.pointer = void 0;
    this.clearVector();
    this.emit("update");
    this.emit("pointerup", pointer);
  }
  forceUpdate() {
    var pointer = this.pointer;
    if (!pointer || !pointer.isDown) {
      return this;
    }
    this.onKeyDown(pointer);
    return this;
  }
};
Object.assign(
  TouchCursor.prototype,
  EventEmitterMethods_default
);
var TouchCursor_default = TouchCursor;

// node_modules/phaser3-rex-plugins/plugins/touchcursor.js
var touchcursor_default = TouchCursor_default;

// node_modules/phaser3-rex-plugins/plugins/input/virtualjoystick/VirtualJoyStick.js
var GetValue3 = Phaser.Utils.Objects.GetValue;
var VirtualJoyStick = class {
  constructor(scene, config) {
    if (config === void 0) {
      config = {};
    }
    var eventEmitter = GetValue3(config, "eventEmitter", void 0);
    var EventEmitterClass = GetValue3(config, "EventEmitterClass", void 0);
    this.setEventEmitter(eventEmitter, EventEmitterClass);
    config.eventEmitter = this.getEventEmitter();
    this.scene = scene;
    this.base = void 0;
    this.thumb = void 0;
    this.touchCursor = void 0;
    this.setRadius(GetValue3(config, "radius", 100));
    this.addBase(GetValue3(config, "base", void 0), config);
    this.addThumb(GetValue3(config, "thumb", void 0));
    var x = GetValue3(config, "x", 0);
    var y = GetValue3(config, "y", 0);
    this.base.setPosition(x, y);
    this.thumb.setPosition(x, y);
    if (GetValue3(config, "fixed", true)) {
      this.setScrollFactor(0);
    }
    this.boot();
  }
  destroy() {
    this.destroyEventEmitter();
    this.base.destroy();
    this.thumb.destroy();
    this.scene = void 0;
    this.base = void 0;
    this.thumb = void 0;
    this.touchCursor = void 0;
  }
  createCursorKeys() {
    return this.touchCursor.createCursorKeys();
  }
  get forceX() {
    return this.touchCursor.forceX;
  }
  get forceY() {
    return this.touchCursor.forceY;
  }
  get force() {
    return this.touchCursor.force;
  }
  get rotation() {
    return this.touchCursor.rotation;
  }
  get angle() {
    return this.touchCursor.angle;
  }
  get up() {
    return this.touchCursor.upKeyDown;
  }
  get down() {
    return this.touchCursor.downKeyDown;
  }
  get left() {
    return this.touchCursor.leftKeyDown;
  }
  get right() {
    return this.touchCursor.rightKeyDown;
  }
  get noKey() {
    return this.touchCursor.noKeyDown;
  }
  get pointerX() {
    return this.touchCursor.end.x;
  }
  get pointerY() {
    return this.touchCursor.end.y;
  }
  get pointer() {
    return this.touchCursor.pointer;
  }
  setPosition(x, y) {
    if (this.x === x && this.y === y) {
      return this;
    }
    this.x = x;
    this.y = y;
    this.forceUpdateThumb();
    return this;
  }
  set x(value) {
    if (this.x === value) {
      return;
    }
    this.base.x = value;
    this.thumb.x = value;
  }
  set y(value) {
    if (this.y === value) {
      return;
    }
    this.base.y = value;
    this.thumb.y = value;
  }
  get x() {
    return this.base.x;
  }
  get y() {
    return this.base.y;
  }
  setVisible(visible) {
    this.visible = visible;
    return this;
  }
  toggleVisible() {
    this.visible = !this.visible;
    return this;
  }
  get visible() {
    return this.base.visible;
  }
  set visible(visible) {
    this.base.visible = visible;
    this.thumb.visible = visible;
  }
  get enable() {
    return this.touchCursor.enable;
  }
  set enable(value) {
    this.touchCursor.setEnable(value);
  }
  setEnable(e) {
    if (e === void 0) {
      e = true;
    }
    this.enable = e;
    return this;
  }
  toggleEnable() {
    this.setEnable(!this.enable);
    return this;
  }
  setRadius(radius) {
    this.radius = radius;
    return this;
  }
  addBase(gameObject, config) {
    if (this.base) {
      this.base.destroy();
    }
    if (gameObject === void 0) {
      gameObject = this.scene.add.circle(0, 0, this.radius).setStrokeStyle(3, 255);
    }
    if (config === void 0) {
      config = {};
    }
    config.eventEmitter = this.getEventEmitter();
    this.touchCursor = new touchcursor_default(gameObject, config);
    this.base = gameObject;
    return this;
  }
  addThumb(gameObject) {
    if (this.thumb) {
      this.thumb.destroy();
    }
    if (gameObject === void 0) {
      gameObject = this.scene.add.circle(0, 0, 40).setStrokeStyle(3, 65280);
    }
    this.thumb = gameObject;
    return this;
  }
  setScrollFactor(scrollFactor) {
    this.base.setScrollFactor(scrollFactor);
    this.thumb.setScrollFactor(scrollFactor);
    return this;
  }
  boot() {
    this.on("update", this.update, this);
  }
  // Internal method
  update() {
    var touchCursor = this.touchCursor;
    var x = this.base.x;
    var y = this.base.y;
    if (touchCursor.anyKeyDown) {
      if (touchCursor.force > this.radius) {
        var rad = touchCursor.rotation;
        x += Math.cos(rad) * this.radius;
        y += Math.sin(rad) * this.radius;
      } else {
        x += touchCursor.forceX;
        y += touchCursor.forceY;
      }
    }
    this.thumb.x = x;
    this.thumb.y = y;
    return this;
  }
  forceUpdateThumb() {
    this.touchCursor.forceUpdate();
    return this;
  }
};
Object.assign(
  VirtualJoyStick.prototype,
  EventEmitterMethods_default
);
var VirtualJoyStick_default = VirtualJoyStick;

// node_modules/phaser3-rex-plugins/plugins/virtualjoystick.js
var virtualjoystick_default = VirtualJoyStick_default;
export {
  virtualjoystick_default as default
};
